<template>
  <div class="card">
    <div class="card-header py-2">
      {{ $t('debug') }}
    </div>
    <div class="card-body p-2">
      <button class="btn btn-primary" :disabled="countingPhotoCache" @click="countPhotoCache">
        <Spinner v-if="countingPhotoCache" margin-right="20px" height="20px" /> {{ $t('countPhotoCache') }} <template v-if="photoCacheCount">({{ photoCacheCount }})</template>
      </button><br><br>
      <b-form-checkbox class="display-inline marginright5" v-model="debugEnabled"></b-form-checkbox>
      <span @click="debugEnabled = !debugEnabled">Włącz debug</span><br><br>
      <button class="btn btn-primary" @click="downloadLogs">Ściągnij logi</button><br><br>
      <button class="btn btn-primary" @click="noSleepToggle">{{ noSleepActive ? $t('noSleepActive') : $t('noSleepInactive') }}</button><br><br>
      <template v-if="window.VITE_BUILD_DATE"><span>{{ $t('buildDate') }}: {{ formatDateSecondsEpoch(parseInt(window.VITE_BUILD_DATE, 10) * 1000) }}</span><br><br></template>
      <b-form-checkbox class="display-inline marginright5" v-model="gridDebug"></b-form-checkbox>
      <span @click="gridDebug = !gridDebug">{{ $t('gridDebug') }}</span><br><br>
      <router-link :to="{ 'name': 'cache' }" target="_blank">Show cache files</router-link><br><br>
      <router-link :to="{ 'name': 'tools' }" target="_blank">Show tools</router-link><br><br>
      <router-link :to="{ 'name': 'weather' }" target="_blank">Weather tables</router-link>
    </div>
  </div>
</template>

<script lang="ts">
import BaseComponent from '@/components/Base.vue';
import { defineComponent } from "vue";
import * as opfs_utils from '@/ts/utils/opfs';
import { AlertStatus } from '@/ts/types';
import { EventBus } from '@/ts/EventBus';
import { downloadDebugMessages } from '@/ts/debug';

export default defineComponent({
  extends: BaseComponent,
  data() {
    return {
      countingPhotoCache: false,
      photoCacheCount: 0,
      noSleepActive: false,
      gridDebug: false,
      debugEnabled: window.debugEnabled,
    };
  },
  mounted() {
    EventBus.$on('activateNoSleep', () => {
      this.noSleepToggle();
    });
  },
  methods: {
    async countPhotoCache() {
      this.countingPhotoCache = true;
      this.photoCacheCount = 0;
      await opfs_utils.openDirectory();
      const entries = window.mediaDirHandle.values();
      for await (const entry of entries) {
        if (entry.kind == 'file') {
          this.photoCacheCount += 1;
          await window.mediaDirHandle.getFileHandle(entry.name, { create: false });
        }
      }
      this.countingPhotoCache = false;
      this.createAlert(AlertStatus.success, String(this.photoCacheCount), 2000);
    },
    noSleepToggle() {
      if (this.noSleepActive) {
        window.noSleep.disable();
        this.noSleepActive = false;
      } else {
        window.noSleep.enable();
        this.noSleepActive = true;
      }
    },
    downloadLogs() {
      if (!downloadDebugMessages()) {
        window.alert('Brak logów do pobrania.');
      }
    },
    onGridDebugChange() {
      if (this.gridDebug) {
        window.layerControl.addOverlay(window.gridDebugLayer, 'gridDebug');
        window.gridDebugLayer.addTo(window.mainmap);
      } else {
        window.gridDebugLayer.removeFrom(window.mainmap);
        window.layerControl.removeLayer(window.gridDebugLayer);
      }
    },
  },
  watch: {
    "gridDebug": [{handler: "onGridDebugChange"}],
    debugEnabled(enabled: boolean) {
      window.debugEnabled = enabled;
    },
  }
});

</script>